import { UICoinProductView } from '../../../../../../shared/scripts/store/UICoinProductView.ts';
import { ClientUserState } from '../../../../../../shared/scripts/ClientUserState.ts';
import { UIMDeviceHandler } from '../../../UIMDeviceHandler.ts';
import { UIMMobileWebviewCommunication } from '../../../../ui_mobile_communication/UIMMobileWebviewCommunication.ts';
import { MobileWebviewCommunicationActions } from '@colonist/mobile';
import { UICheckoutAjaxEndPoints } from '../../../../../../shared/scripts/ui_checkout/UICheckoutAjaxEndPoints.ts';
import { doActionIfLoggedIn, isPurchaseUnavailableOnPlatform, showUnavailableOnMobilePopup } from '../../../../../../shared/scripts/store/StoreUtils.ts';
import { AudioManager, AudioType } from '@colonist/audio';
import { createDivIn } from '../../../../../../shared/scripts/ui_utils/DomUtils.ts';
import { UIMDoubleTapPurchaseController } from '../../../store/UIMDoubleTapPurchaseController.ts';
import { sendDoubleTapPaymentAbandonedAnalytic, sendPurchaseSessionStartedAnalytic } from '../../../../../../shared/scripts/analytics/sendPurchaseFunnelAnalytic.ts';
export class UIMCoinProductView extends UICoinProductView {
    handleBuyButtonClicked() {
        AudioManager.play(AudioType.Click);
        if (isPurchaseUnavailableOnPlatform()) {
            showUnavailableOnMobilePopup();
            return;
        }
        doActionIfLoggedIn(()=>this.purchaseCoins());
    }
    purchaseCoins() {
        if (!ClientUserState.userState) return;
        const doubleTapPurchaseController = UIMDoubleTapPurchaseController.getInstance();
        const isDoubleTapPurchaseInitialized = doubleTapPurchaseController != undefined;
        if (!isDoubleTapPurchaseInitialized) {
            this.executeNonDoubleTabCheckout();
            return;
        }
        this.buyButton.classList.add('loading');
        doubleTapPurchaseController.startPurchase({
            productName: this.product.getProductName(),
            usdCentsAmount: this.product.price,
            storeProductType: this.product.storeProductType,
            productType: this.product.type,
            itemQuantity: this.product.itemQuantity,
            onPaymentSheetShown: ()=>sendPurchaseSessionStartedAnalytic({
                    storeProductType: this.product.storeProductType,
                    productType: this.product.type,
                    method: 'doubleTap'
                }),
            onPurchaseCancel: ()=>sendDoubleTapPaymentAbandonedAnalytic({
                    storeProductType: this.product.storeProductType,
                    productType: this.product.type
                }),
            onPurchaseFinished: ({ shouldExecuteFallbackPurchase = false })=>this.onDoubleTapPurchaseFinished(shouldExecuteFallbackPurchase)
        });
    }
    onDoubleTapPurchaseFinished(shouldExecuteFallbackPurchase) {
        this.buyButton.classList.remove('loading');
        if (shouldExecuteFallbackPurchase) this.executeNonDoubleTabCheckout();
    }
    executeNonDoubleTabCheckout() {
        if (UIMDeviceHandler.shouldEnableNativePaymentsOnMobile() == true) {
            this.executeNativePaymentPurchase();
            return;
        }
        this.executeStripePurchaseSession();
    }
    executeNativePaymentPurchase() {
        if (!ClientUserState.userState) return;
        this.buyButton.classList.add('loading');
        sendPurchaseSessionStartedAnalytic({
            storeProductType: this.product.storeProductType,
            productType: this.product.type,
            method: 'nativeIap'
        });
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.PurchaseProduct, {
            productId: this.product.mobileIAPSKUId,
            userId: ClientUserState.userState.id
        });
    }
    executeStripePurchaseSession() {
        sendPurchaseSessionStartedAnalytic({
            storeProductType: this.product.storeProductType,
            productType: this.product.type,
            method: 'stripeCheckout'
        });
        void UICheckoutAjaxEndPoints.executeStripeColonistProductPurchaseSession(this.product.storeProductType, this.product.type, this.product.itemQuantity);
    }
    constructor(container, product, localizedPriceData){
        super(container, product, undefined, localizedPriceData);
        createDivIn(this.buyButton, 'loading-spinner');
    }
}
